import { createAsyncThunk } from "@reduxjs/toolkit";
import { logout } from "./LoginSlice";
import { logoutUser } from "./AccountLogoutThunk";

/**
 * fetch all Industrysectorcategories entries
 */
export const fetchIndustrysectorparentItems = createAsyncThunk(
  "industrysectorcategories/fetchParent",
  async (_, thunkAPI) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/industrysectorparent`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const addIndustrysectorparentItems = createAsyncThunk(
  "industrysectorcategories/fetchParent",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/industrysectorparent`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateIndustrysectorparentItems = createAsyncThunk(
  "industrysectorcategories/updateParent",
  async (data, thunkAPI) => {
    const body = JSON.stringify(data)
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/industrysectorparent?_id=${data._id}`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
      body: body
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
export const deleteIndustrysectorparentItems = createAsyncThunk(
  "industrysectorcategories/updateParent",
  async (data, thunkAPI) => {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/api/industrysectorparent?_id=${data._id}`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "admin"
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logout());
      thunkAPI.dispatch(logoutUser());
      window.location.href = "/";
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);